__turbopack_context__.v({
  "manaSymbol": "manaSymbol-module-scss-module__4Xrw7W__manaSymbol",
  "medium": "manaSymbol-module-scss-module__4Xrw7W__medium",
  "small": "manaSymbol-module-scss-module__4Xrw7W__small",
});
